var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"layout-menu"},_vm._l((_vm.menus),function(menu,index){return _c('layout-menu-button',{key:'layout-menu-button-top-' + index,attrs:{"to":menu.name}},[_c(menu.componentName,{tag:"component",attrs:{"to":menu.name}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }